import { graphql } from '@/generated/gql';

export const FILES_DEMAND_QUERY = graphql(/* GraphQL */ `
  query FilesByDemand($id: UUID!) {
    tesseract {
      demand(id: $id) {
        id
        status
        files {
          id
          isSharedWithSupplier
          quoteId
          negotiationCaseId
          negotiationCaseSequence
          createdAt
          updatedAt
        }
        permissions {
          read
          write
          assign
        }
        negotiationCases {
          nodes {
            id
            status
          }
        }
      }
    }
  }
`);
